import React from "react";
import CrossAttachmentAssessment from "./CrossAttachmentAssessment";
// css comes in libraryBox.css in hw

const OpenLibraryImg = ({ sQuestion, questionNumber, filter }) => {
  console.log(sQuestion, "idhr");
  return (
    <>
      <div className="mt-3 library_img_box">
        <span className="library_mcq_question ">
          Q{questionNumber + 1}. {sQuestion?.title}
        </span>
        {
          <div style={{ fontSize: "15px" }}>
            {(sQuestion?.question?.domain?.name ||
              sQuestion?.question?.domain_id?.name) ??
              "-"}{" "}
            |{" "}
            {(sQuestion?.question?.skill?.name ||
              sQuestion?.question?.skill_id?.name) ??
              "-"}{" "}
            |{" "}
            {(sQuestion?.question?.type?.name ||
              sQuestion?.question?.type_id?.name) ??
              "MCQ"}{" "}
            | {sQuestion?.question?.difficulty_level?.name ?? "-"} |
            {" " +
              (sQuestion?.question?.book?.name ||
                sQuestion?.question?.book_id?.bookName) ?? "-"}{" "}
            :{" "}
            {(sQuestion?.question?.chapter?.chapterName ||
              sQuestion?.question?.chapter_id?.chapterName) ??
              "-"}
          </div>
        }
        <div className="mt-3 ms-4 p-1 open_library_attach_container">
          {sQuestion?.attachments?.length > 0 &&
            sQuestion?.attachments?.map((attachment, index) => (
              <CrossAttachmentAssessment key={index} attachment={attachment} />
            ))}
        </div>
      </div>
    </>
  );
};

export default OpenLibraryImg;
